/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { inviteUserDataRoleSchema } from './InviteUserDataRoleSchema'

export const inviteUserDataSchema = z.object({
	organisationId: z.string(),
	invitations: z.array(z.object({ email: z.string() })),
	role: inviteUserDataRoleSchema,
	inviterUserId: z.string().nullable().optional(),
})

export type InviteUserDataSchema = z.infer<typeof inviteUserDataSchema>
